module.exports = __webpack_public_path__ + "static/regen-pads-44d8363c6a7ddb9b8358f83f34f724a5.jpg";